import {
    Typography,
    MenuItem,
} from "@mui/material";
import { CustomSelect, CustomInput, CustomBreadCrumbs, Button } from '../../components';
import Grid from '@mui/material/Unstable_Grid2';
import { RefundGrid } from "../../components/RefundGrid";
import { useViewRefunds } from "./hook";
import { event } from "react-ga";

export const ViewRefunds = (): JSX.Element => {
    const { 
        searchFor, 
        searchMode, 
        refunds, 
        statuses,
        status,
        total, 
        pageSize, 
        startIndex, 
        searchForOpts, 
        onChange, 
        onPageChange, 
        onPageSizeChange, 
        onChangeSelect, 
        onApplyFilters 
    } = useViewRefunds();

    return (
        <>
            <Grid xs={12} sx={{ mb: 2 }}>
                <CustomBreadCrumbs path="Home/View Warranties" />
            </Grid>
            <Grid container columns={{ xs: 12, sm: 10, md: 10, lg: 12 }} justifyContent="space-between" sx={{ mb: 3 }}>
                <Grid xs={12} sm={5} md={5} lg={8}>
                    <Typography textAlign={{ xs: "center", sm: "start" }} variant="h4" sx={{ color: "#1BA0E9", fontWeight: 600, fontSize: 25 }} >
                        View Refunds
                    </Typography>
                    <Typography textAlign={{ xs: "center", sm: "start" }} sx={{ fontSize: 14, marginTop: '10px' }} >
                        What would you like to view?
                    </Typography>
                </Grid>
                <Grid xs={12} sm={5} md={5} lg={4} display="">
                    <CustomSelect value={status} onChange={(event) => onChangeSelect("status", event)} width={"100%"} name="filter" placeholder="" label="Refund status">
                        <MenuItem value={0} >All</MenuItem>
                        { statuses && statuses.filter((i) => i.active !== false).map((status) => {
                            return (
                                <MenuItem value={status.id}>{ status.description }</MenuItem>
                            )
                        }) }
                    </CustomSelect>
                </Grid>
            </Grid>

            <Grid container sx={{ mb: 1 }} columns={{ xs: 12, sm: 12, lg: 12 }} columnSpacing={{ lg: 2 }} >
                <Grid container sm={12} xs={12} lg={10} columnSpacing={{ xs: 0, sm: 2 }} rowSpacing={{ xs: 2 }}>
                    <Grid sx={{ width: "100%" }} xs={12} sm={6} lg={4}>
                        <CustomSelect value={searchMode} onChange={(event) => onChangeSelect("searchMode", event)} width={"100%"} placeholder="Leads with Phone #s Like" label="Search for" name="search" >
                            <MenuItem value={0} >All</MenuItem>
                            { searchForOpts && searchForOpts.filter((val) => val.active !== false).map((opt) => {
                                return (
                                    <MenuItem value={opt.id}>{ opt.description }</MenuItem>
                                )
                            }) }
                        </CustomSelect>
                    </Grid>
                    <Grid sx={{ width: "100%" }} xs={12} sm={6} lg={4}>
                        <CustomInput name="searchFor" value={searchFor} onChange={onChange} width={"100%"} height={35} label={{ text: "Search For" }} type="text" />
                    </Grid>
                    <Grid xs={12} sm={12} lg={2} display="flex" alignItems="end">
                        <Button width={120} height={40} label='Apply' onClick={onApplyFilters} />
                    </Grid>
                </Grid>
            </Grid>
            <RefundGrid rows={refunds} onPageChange={onPageChange} onPageSizeChange={onPageSizeChange} page={startIndex} pageSize={pageSize} total={total}  />
        </>
    )
}